<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.roleUser }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <!-- {{$moment('30-02-2023', 'DD-MM-YYYY').format('DD-MM-YYYY')}} -->
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    :disabled="(!supers && item.kodeRole == 'super') || (!supers && item.kodeRole == 'super_user')"
                  >
                    <CIcon name="cil-pencil" />
                  </b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="(!supers && item.kodeRole == 'super') || (!supers && item.kodeRole == 'super_user')"
                  >
                    <CIcon name="cil-trash" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input :listUser="listUser" :listRole="listRole" :listMitra="listMitra" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :listUser="listUser" :listRole="listRole" :listMitra="listMitra" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "roleUser",
  data() {
    return {
      data: {},
      listUser: [],
      listRole: [],
      listMitra: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "username",
          label: "User",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaRole",
          label: "Role",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaMitra",
          label: "Mitra User",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaKoordinator",
          label: "Koordinator",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaCabang",
          label: "Cabang",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaCapem",
          label: "Capem",
          sortDirection: "desc",
          _style: "width: 14%;",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    supers() {
      return this.$store.state.role_aktif.kodeRole == "super";
    },
  },
  mounted() {
    const vm = this;
    vm.getDatas();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listRoleUser = await vm.$axios.post("poolRole/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listRoleUser", listRoleUser);
      vm.items =
        listRoleUser.data.status == 200
          ? listRoleUser.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                namaMitra: x.namaMitra || " - ",
                namaKoordinator: x.namaKoordinator || " - ",
                namaCabang: x.namaCabang || " - ",
                namaCapem: x.namaCapem || " - ",
                //edit
                user: { username: x.username, id: x.masterUserId },
                role: { namaRole: x.namaRole, id: x.roleId },
                mitra: x.mitraId ? { namaMitra: x.namaMitra, id: x.mitraId } : null,
                koordinator: x.koordinatorId ? { namaKoordinator: x.namaKoordinator, id: x.koordinatorId } : null,
                cabang: x.cabangId ? { namaCabang: x.namaCabang, id: x.cabangId } : null,
                capem: x.capemId ? { namaCapem: x.namaCapem, id: x.capemId } : null,
              };
            })
          : [];
      vm.totalRows = parseInt(listRoleUser.data.count);
      vm.loading = false;

      let listUser = await vm.$axios.post("user/ALL");
      console.log("listUser", listUser);
      vm.listUser =
        listUser.data.status == 200
          ? listUser.data.data.map((x) => {
              return {
                ...x,
                id: x.masterUserId,
              };
            })
          : [];

      let listRole = await vm.$axios("role/list");
      vm.listRole = listRole.data.status == 200 ? listRole.data.data : [];

      let listMitra = await vm.$axios("mitra/list");
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
